module.exports = __webpack_public_path__ + "11d56a2057628f92fa5f0d47ad2af878.svg";